import { createStandardAction } from 'typesafe-actions';

const PAGES_HISTORY_CALENDAR_SELECT_DATE = 'PAGES_HISTORY_CALENDAR_SELECT_DATE';
const PAGES_HISTORY_CALENDAR_SELECT_MONTH = 'PAGES_HISTORY_CALENDAR_SELECT_MONTH';
const PAGES_HISTORY_CALENDAR_SELECT_YEAR = 'PAGES_HISTORY_CALENDAR_SELECT_YEAR';

const PAGES_HISTORY_CALENDAR_UPDATE_SELECTED_DATE = 'PAGES_HISTORY_CALENDAR_UPDATE_SELECTED_DATE';
const PAGES_HISTORY_CALENDAR_UPDATE_SELECTED_MONTH = 'PAGES_HISTORY_CALENDAR_UPDATE_SELECTED_MONTH';
const PAGES_HISTORY_CALENDAR_UPDATE_SELECTED_YEAR = 'PAGES_HISTORY_CALENDAR_UPDATE_SELECTED_YEAR';

const PAGES_HISTORY_CALENDAR_RESET_STATE = 'PAGES_HISTORY_CALENDAR_RESET_STATE';

const PAGES_HISTORY_CALENDAR_START_SAGA = 'PAGES_HISTORY_CALENDAR_START_SAGA';
const PAGES_HISTORY_CALENDAR_CANCEL_SAGA = 'PAGES_HISTORY_CALENDAR_CANCEL_SAGA';

export const selectPagesHistoryCalendarDate = createStandardAction(PAGES_HISTORY_CALENDAR_SELECT_DATE)<string>();
export const selectPagesHistoryCalendarMonth = createStandardAction(PAGES_HISTORY_CALENDAR_SELECT_MONTH)<
  string | number
>();
export const selectPagesHistoryCalendarYear = createStandardAction(PAGES_HISTORY_CALENDAR_SELECT_YEAR)<
  string | number
>();

export const updatePagesHistoryCalendarSelectedDate = createStandardAction(PAGES_HISTORY_CALENDAR_UPDATE_SELECTED_DATE)<
  string
>();
export const updatePagesCalendarSelectedMonth = createStandardAction(PAGES_HISTORY_CALENDAR_UPDATE_SELECTED_MONTH)<
  string
>();
export const updatePagesCalendarSelectedYear = createStandardAction(PAGES_HISTORY_CALENDAR_UPDATE_SELECTED_YEAR)<
  string
>();

export const resetPagesCalendarState = createStandardAction(PAGES_HISTORY_CALENDAR_RESET_STATE)();

export const startPagesCalendarSaga = createStandardAction(PAGES_HISTORY_CALENDAR_START_SAGA)();
export const cancelPagesCalendarSaga = createStandardAction(PAGES_HISTORY_CALENDAR_CANCEL_SAGA)();



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryCalendar/actions.ts